module.exports = __webpack_public_path__ + "static/media/1_A1_17.d8e8b80a.png";